import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import api from "../../../services/api";
import { Background, Container, Titulo, Hr, Form, InputLabel, ButtonAdd, BigButton, H4, Table, Inputs } from "./style";
import Auth from "../../../services/auth";
import GoBack from "../../../components/GoBack";
import { Swal, Toast } from "../../../services/SwalTemplates";
import { IoTrashOutline, IoTimeOutline } from "react-icons/io5";
import ModalEditHorario from "../../../components/Modal/Coord/TrocaHorarios/Horarios.js";
import formatDates from "../../../utils/formatDates.js";
import convertToISODate from "../../../utils/convertToISODate.js";
import PDF from "../../../assets/urls/url_pdf.js";
import "./styles.css";

export default function EdicaoProjeto() {
  const location = useLocation();
  const [id] = useState(Auth.id());
  const [projeto, setProjeto] = useState(location.state?.projeto || "");
  const [idProjeto] = useState(location.state?.id_projeto || 0);
  const [matricula_colaborador] = useState(location.state?.matricula_colaborador || 0);
  const [colaboradorPrincipal] = useState(location.state?.colaborador || "");
  const [data_inicio, setData_inicio] = useState(location.state?.data_inicio ? convertToISODate(location.state?.data_inicio) : "");
  const [data_fim, setData_fim] = useState(location.state?.data_fim ? convertToISODate(location.state?.data_fim) : "");
  const [anexo, setAnexo] = useState(location.state?.anexo || "");
  const [horario_inicio, setHorario_inicio] = useState("");
  const [horario_fim, setHorario_fim] = useState("");
  const [dia_semana, setDia_semana] = useState("");
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [horarioEdit, setHorarioEdit] = useState("");
  const [rowTable, setRowTable] = useState([]);
  const [changed, setChanged] = useState(false);
  const [file, setFile] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [dragActive, setDragActive] = useState(false);
  const [keepOldPdf, setKeepOldPdf] = useState(true);

  useEffect(() => {
    api
      .get(`/coord/projetoslancamentoslist?idProjeto=${location.state.id}`)
      .then((response) => {
        setRowTable(response.data.lancamentos || []);
      })
      .catch((error) => {
        console.error("Erro ao carregar lançamentos:", error);
        Swal.fire({
          title: "Atenção!",
          text: "Não foi possível consultar os lançamentos!",
          icon: "error",
        });
      });

    if (anexo) {
      const pdfUrl = PDF(anexo);
      setFileUrl(pdfUrl);
    }
  }, [location.state.id, anexo]);

  function calcularCargaHoraria(inicio, fim) {
    const [horaInicio, minutoInicio] = inicio.split(":").map(Number);
    const [horaFim, minutoFim] = fim.split(":").map(Number);

    const totalMinutosInicio = horaInicio * 60 + minutoInicio;
    const totalMinutosFim = horaFim * 60 + minutoFim;

    const diferencaMinutos = totalMinutosFim - totalMinutosInicio;
    const cargaHoraria = diferencaMinutos / 60;

    return cargaHoraria.toFixed(2);
  }

  function addRowTable() {
    setChanged(true);
    const carga = calcularCargaHoraria(horario_inicio, horario_fim);

    setRowTable([
      ...rowTable,
      {
        colaborador: colaboradorPrincipal,
        matricula_colaborador: matricula_colaborador,
        dia_semana: dia_semana,
        horario_inicio: horario_inicio,
        horario_fim: horario_fim,
        carga_horaria: parseFloat(carga),
        data_inicio: data_inicio,
        data_fim: data_fim,
      },
    ]);

    setDia_semana("");
    setHorario_inicio("");
    setHorario_fim("");
  }

  function sendObj() {
    if (!dia_semana || !horario_inicio || !horario_fim) {
      return Swal.fire("Atenção!", "Preencha todos os campos!", "warning");
    }
    if (horario_fim <= horario_inicio) {
      return Swal.fire("Atenção!", "Horário final deve ser superior ao horário de início!", "warning");
    }

    const conflito = rowTable.find((r) => {
      if (r.dia_semana === dia_semana) {
        return (
          (horario_inicio >= r.horario_inicio && horario_inicio < r.horario_fim) ||
          (horario_fim > r.horario_inicio && horario_fim <= r.horario_fim) ||
          (horario_inicio <= r.horario_inicio && horario_fim >= r.horario_fim)
        );
      }
      return false;
    });

    if (conflito) {
      return Swal.fire(
        "Atenção!",
        `Já existe horário alocado neste período (${conflito.horario_inicio} - ${conflito.horario_fim})`,
        "warning"
      );
    }

    addRowTable();
  }

  function handleDelete(id, index) {
    Swal.fire({
      title: "Você tem certeza?",
      text: "Você não poderá reverter essa ação!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "Deletar",
      cancelButtonColor: "gray",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (id) {
          const response = await api.delete(`/coord/projetoslancamentos/lancamento?idLancamento=${id}`);
          if (response.data.error) {
            return Swal.fire("Exclusão não permitida!", response.data.error, "warning");
          }
          Toast.fire({
            icon: "success",
            title: "Deletado com sucesso!",
          });
          setRowTable(rowTable.filter((row) => row.id !== id));
        } else {
          Toast.fire({
            icon: "success",
            title: "Deletado com sucesso!",
          });
          setRowTable(rowTable.filter((row, i) => i !== index));
        }
        setChanged(true);
      }
    });
  }

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile?.type === "application/pdf") {
      setFile(selectedFile);
      setFileUrl(URL.createObjectURL(selectedFile));
      setKeepOldPdf(false);
      setChanged(true);
    } else if (selectedFile) {
      Swal.fire("Erro", "Por favor, selecione um arquivo PDF.", "error");
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile?.type === "application/pdf") {
      setFile(droppedFile);
      setFileUrl(URL.createObjectURL(droppedFile));
      setKeepOldPdf(false);
      setChanged(true);
    } else if (droppedFile) {
      Swal.fire("Erro", "Por favor, arraste um arquivo PDF.", "error");
    }
    setDragActive(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setDragActive(false);
  };

  const handleRemovePdf = (e) => {
    e.stopPropagation();
    setFile(null);
    setFileUrl(null);
    setKeepOldPdf(false);
    setAnexo(null);
    setChanged(true);
  };

  async function handleSubmit(e) {
    e.preventDefault();

    if (rowTable.length === 0) {
      return Swal.fire("Atenção!", "Adicione ao menos um lançamento à lista!", "warning");
    }

    const formData = new FormData();

    const data = {
      id: location.state.id,
      id_projeto: idProjeto,
      matricula_colaborador: matricula_colaborador,
      data_inicio: data_inicio,
      data_fim: data_fim,
      anexo: keepOldPdf ? anexo : null,
      dados: rowTable,
    };

    formData.append("data", JSON.stringify(data));

    if (file) {
      formData.append("file", file);
    }

    try {
      const response = await api.patch(`/coord/projetoslancamentos`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }

      Toast.fire({
        icon: "success",
        title: "Atualizado com sucesso!",
      });

      setTimeout(() => {
        window.location.href = "/projetoslancamentos";
      }, 1000);
    } catch (error) {
      console.error(error);
      Swal.fire("Atenção!", "Erro ao atualizar os dados!", "error");
    }
  }

  const cargaTotal = rowTable.reduce((acc, r) => acc + parseFloat(r.carga_horaria || 0), 0).toFixed(2);

  return (
    <Background>
      <GoBack />
      <Container>
        <Titulo>Edição de Lançamentos de Projetos</Titulo>
        <Hr />
        <h3>{projeto}</h3>
        <h4>
          Colaborador: {colaboradorPrincipal} - Matrícula: {matricula_colaborador}
        </h4>

        <Form>
          <form onSubmit={handleSubmit}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "20px",
                  marginTop: "20px",
                  flexWrap: "wrap",
                }}
              >
                <InputLabel>
                  <label>Data Início</label>
                  <input
                    type="date"
                    value={data_inicio}
                    onChange={(e) => {
                      setData_inicio(e.target.value);
                      setChanged(true);
                    }}
                    required
                    style={{ width: "340px" }}
                  />
                </InputLabel>

                <InputLabel>
                  <label>Data Fim</label>
                  <input
                    type="date"
                    value={data_fim}
                    onChange={(e) => {
                      setData_fim(e.target.value);
                      setChanged(true);
                    }}
                    required
                    style={{ width: "340px" }}
                  />
                </InputLabel>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "30px",
                }}
              >
                <label
                  style={{
                    fontSize: "18px",
                    fontWeight: "500",
                    marginBottom: "15px",
                    textAlign: "center",
                  }}
                >
                  Anexo PDF (opcional)
                </label>

                {fileUrl && (
                  <iframe
                    src={fileUrl}
                    title="Preview PDF"
                    style={{
                      width: "700px",
                      height: "400px",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      marginBottom: "15px",
                    }}
                  />
                )}

                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                  style={{
                    width: "700px",
                    minHeight: "120px",
                    border: dragActive ? "2px dashed #007bff" : "2px dashed #ccc",
                    borderRadius: "8px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "20px",
                    backgroundColor: dragActive ? "#f0f8ff" : "#fafafa",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                  }}
                  onClick={() => document.getElementById("pdf-input-edit").click()}
                >
                  <input id="pdf-input-edit" type="file" accept=".pdf" onChange={handleFileChange} style={{ display: "none" }} />

                  {file || (keepOldPdf && anexo) ? (
                    <div style={{ textAlign: "center", width: "100%" }}>
                      <div style={{ fontSize: "16px", fontWeight: "600", marginBottom: "8px", color: "#333" }}>
                        {file ? file.name : anexo ? "PDF Anexado" : "Nenhum arquivo"}
                      </div>
                      {file && (
                        <div style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>
                          Tamanho: {(file.size / 1024 / 1024).toFixed(2)} MB
                        </div>
                      )}
                      <button
                        type="button"
                        onClick={handleRemovePdf}
                        style={{
                          padding: "8px 20px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontSize: "14px",
                          fontWeight: "500",
                        }}
                      >
                        Remover PDF
                      </button>
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", color: "#666" }}>
                      {dragActive ? "Solte o PDF aqui" : "Arraste ou clique para enviar um novo PDF"}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="table-container">
              <table className="table" style={{ marginTop: 20 }}>
                <thead>
                  <tr>
                    <th>Dia</th>
                    <th>Início</th>
                    <th>Fim</th>
                    <th>Carga (h)</th>
                    <th>Data Início</th>
                    <th>Data Fim</th>
                    {/* <th></th> */}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {rowTable.map((r, i) => (
                    <tr key={i}>
                      <td data-title="Dia">{r.dia_semana}</td>
                      <td data-title="Início">{r.horario_inicio}</td>
                      <td data-title="Fim">{r.horario_fim}</td>
                      <td data-title="Carga">{r.carga_horaria}</td>
                      <td data-title="Data Início">{formatDates(r.data_inicio)}</td>
                      <td data-title="Data Fim">{formatDates(r.data_fim)}</td>
                      {/* <td data-title="Editar Horário">
                        <IoTimeOutline
                          title="Editar Horário"
                          style={{ fontSize: "25px", cursor: "pointer" }}
                          onClick={() => {
                            setHorarioEdit(r);
                            setShowModalEdit(true);
                          }}
                        />
                      </td> */}
                      <td data-title="Excluir">
                        <IoTrashOutline
                          title="Excluir"
                          style={{ fontSize: "25px", cursor: "pointer" }}
                          onClick={() => {
                            handleDelete(r.id, i);
                          }}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ marginTop: "15px", fontWeight: "bold", fontSize: "16px", textAlign: "center" }}>
              Carga Horária Total: {cargaTotal}h
            </div>

            <Hr />
            <H4>Adicionar Novo Horário</H4>
            <Inputs>
              <InputLabel>
                <label>Dia da Semana</label>
                <select value={dia_semana} onChange={(e) => setDia_semana(e.target.value)} id="dia_semana">
                  <option disabled value="">
                    Selecione
                  </option>
                  <option>SEG</option>
                  <option>TER</option>
                  <option>QUA</option>
                  <option>QUI</option>
                  <option>SEX</option>
                  <option>SÁB</option>
                  <option>DOM</option>
                </select>
              </InputLabel>
              <InputLabel>
                <label>Horário Início</label>
                <input type="time" value={horario_inicio} onChange={(e) => setHorario_inicio(e.target.value)} />
              </InputLabel>
              <InputLabel>
                <label>Horário Fim</label>
                <input type="time" value={horario_fim} onChange={(e) => setHorario_fim(e.target.value)} />
              </InputLabel>
              <ButtonAdd type="button" onClick={() => sendObj()}>
                +
              </ButtonAdd>
            </Inputs>

            <div style={{ display: "flex", justifyContent: "center", gap: "10px", marginTop: "20px" }}>
              <BigButton style={{ display: changed ? "" : "none" }} type="submit">
                Salvar Alterações
              </BigButton>
              <Link to="/projetoslancamentos" className="link" style={{ display: changed ? "" : "none" }}>
                <BigButton style={{ background: "#e8343d" }}>Cancelar</BigButton>
              </Link>
            </div>
          </form>
        </Form>

        <ModalEditHorario
          showModalEdit={showModalEdit}
          setShowModalEdit={setShowModalEdit}
          dados={horarioEdit}
          rowTable={rowTable}
          setRowTable={setRowTable}
          setChanged={setChanged}
        />
      </Container>
    </Background>
  );
}
